import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {getZoomIntegration} from '../../../../helpers/models/conferenceHelpers';
import {getCompanyUrl} from '../../../../store/data/company/companySelectors';
import {getHasAICompose} from '../../../../store/featureFlags/featureFlagsSelectors';
import {CommentComposerControls} from './commentComposerControls';

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  zoomIntegration: getZoomIntegration,
  hasAICompose: getHasAICompose,
  companyUrl: getCompanyUrl,
}));

export const CommentComposerControlsContainer = connect(mapStateToProps)(CommentComposerControls);
